// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Do9Ij0Vi7yynNpw4ULbA","icon":"_3UOH6H1bO3OK-9Q5S3uSpD","title":"_1SpCEnI70UP7t7y2UuCbyP","Email":"_3HPPYOO6ZT8QrqfcYj1InX","Signer":"_2A__WjjC9EA36NWDKI35YZ","Subraya":"_28RJ6YOuPvEbeQQlLIG4aa"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/BioSigners/styles.css
// module id = 2850
// module chunks = 0